import Box from '@mui/material/Box';
import { useSelector } from 'react-redux';
import { useTheme, useMediaQuery } from '@mui/material';

const HelloSelection = () => {
    const customization = useSelector((state) => state.customization);
    const email = customization?.userDetail?.[0]?.user_detail?.email ?? '';

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // <600px

    // Limit email length for mobile
    const displayEmail = isMobile && email.length > 18 ? email.slice(0, 18) + '...' : email;

    return (
        <Box sx={{ padding: '10px', fontSize: '20px', alignItems: 'center' }} onDragStart={(e) => e.preventDefault()}>
            Hello {displayEmail}
        </Box>
    );
};

export default HelloSelection;
